(function($) {
	'use strict';

	$.widget('msv.modal', {
		_create: function() {
			this.modalOptions = {
				items: {},
				closeBtnInside: true,
				type: 'inline',
				removalDelay: 500,
				mainClass: 'mfp-zoom-in'
			};
			this.options = {
				autoOpen: {
					id: null,
					expires: 365,
					maxViewsPerUser: 1
				}
			};

			var self = this;
			if (this.element.data('auto-id')) {
				this.options.autoOpen.id = this.element.data('auto-id');
				this.modalOptions.items.src = this.element;
			}
			else {
				this.modalOptions.items.src = this.element.attr("href");
			}

			if (this.element.data('auto-expires')) {
				this.options.autoOpen.expires = this.element.data('auto-expires');
			}
			if (this.element.data('auto-max-views')) {
				this.options.autoOpen.maxViewsPerUser = this.element.data('auto-max-views');
			}

			if ($(this.element).data("modal")) {
				this.modalOptions.closeOnBgClick = false;
			}

			if ($(this.element).data('video')) {
				this.modalOptions.mainClass = 'mfp-video mfp-zoom-in';
				this.modalOptions.closeBtnInside = false;

			}

			if ($(this.element).data("modalAnimation")) {
				this.modalOptions.mainClass = $(this.element).data("modalAnimation");
			}

			//only defines open event if it is not an autoopen modal
			if (!this.options.autoOpen.id) {
				this._on({
					'click': function(e) {
						e.preventDefault();
						$.magnificPopup.open(self.modalOptions);
						var container = $.magnificPopup.instance;
						if (container.content.attr('id') === 'modal-video') {
							var video = $(container.content)
							video.find('.modal__video video')[0].currentTime = 0;
							video.find('.modal__video video')[0].play()

							container.wrap.find('.mfp-close').on('click', function() {
								video.find('.modal__video video')[0].pause()
							})
						}


					}
				});
			}
		},
		_init: function() {

			//---- Auto Open Process ----
			if (this.options.autoOpen.id) {
				var cookieId = 'auto-open-modal-' + this.options.autoOpen.id;
				var sessionCookieId = 'auto-open-modal-session-' + this.options.autoOpen.id;
				var startdateCookieId = 'auto-open-modal-startdate-' + this.options.autoOpen.id;
				var startdate = $('#modal-startpage').data('startdate');

				//If there is new startdate, all cookies will be removed, and reset startdatecookie
				if ($.cookie(startdateCookieId) != startdate) {
					$.removeCookie(sessionCookieId);
					$.removeCookie(cookieId);
					$.cookie(startdateCookieId, startdate);
				}

				// popup wasn't opened in this session
				if (!$.cookie(sessionCookieId)) {
					//set as sessionOpened
					$.cookie(sessionCookieId, true);

					//get current user views
					var userCountViews = $.cookie(cookieId);
					if (!userCountViews)
						userCountViews = 0;

					if (userCountViews < this.options.autoOpen.maxViewsPerUser) {
						//increment cookie user views counter
						$.cookie(cookieId, ++userCountViews, { expires: this.options.autoOpen.expires }); //increment cookie user views counter

						//open modal
						$.magnificPopup.open(this.modalOptions);
					}
				}
			}
		}
	});
})(jQuery);